import { useMemo } from 'react';

import { NumberInput } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceOrderFormMethods, MedicalDeviceOrderItemsCountFormBeanPart } from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type ItemsCountFieldProps = MedicalDeviceOrderFormMethods<
   MedicalDeviceOrderItemsCountFormBeanPart,
   'register' | 'watch' | 'setValue' | 'formState' | 'trigger'
>;

const DEFAULT_ITEMS_COUNT = 1;
const MIN_ITEMS_COUNT = 1;
export const ItemsCountField = (props: ItemsCountFieldProps): JSX.Element | null => {
   const device = props.watch('device');

   const maxValue: number | undefined = useMemo(() => {
      return device?.limit;
   }, [device]);

   const defaultValue = useMemo(() => {
      return device?.limit ?? DEFAULT_ITEMS_COUNT;
   }, [device]);

   return (
      <NumberInput
         testId={'itemsCount'}
         controller={props.register('itemsCount', {
            required: isMedicalDeviceFieldRequired(props.watch, 'itemsCount'),
         })}
         label={medicalDevicesTranslationKeys.fields.itemsCount}
         defaultValue={defaultValue}
         max={maxValue}
         min={MIN_ITEMS_COUNT}
      />
   );
};
